import React from "react";
import ServiceDetailLayout from "../../components/service-detail-layout";
import waxBath from "../../assets/img/wax-bath.png";

/**
 * Paraffin Wax Bath Treatment detail page component
 */
const ParaffinWaxBathDetail = () => {
  return (
    <ServiceDetailLayout
      title="Paraffin Wax Bath Treatment"
      description="Professional paraffin wax bath therapy for hands and feet. Effective heat treatment for joints and connective tissues at The Moffat Foot Clinic."
      image={waxBath}
      imageAlt="Paraffin Wax Bath Treatment"
    >
      <h1 className="gs-u-mb+">Paraffin Wax Bath Treatment</h1>
      <p className="text--large gs-u-mb++">
        Paraffin Wax treatments were introduced during the First World War by a
        French Physician but can be traced back to biblical times and the Roman
        Empire.
      </p>

      <p className="gs-u-mb+">
        For over a century, paraffin wax treatments have been a go-to method for
        easing discomfort in muscles and joints, as well as for making the skin
        smoother.
      </p>
      <p className="gs-u-mb++">
        We employ high-quality liquid paraffin wax, known for its exceptional
        heat retention and transfer properties, which warm the feet and ankles,
        allowing the wax to seep into the joints, offering a bit of respite for
        those suffering from arthritis.
      </p>

      <p className="gs-u-mb++">
        Additionally, paraffin wax treatments are beneficial for getting your
        feet ready for a visit to your podiatrist, as they help soften the skin
        and add some moisture. This results in making it simpler to remove
        tough, thick calluses and cracks on the heels.
      </p>

      <h2 className="gs-u-mb+">Benefits of Paraffin Wax Treatment</h2>
      <ul className="gs-u-mb++ benefits-list">
        <li>Cleansing and opening pores of the skin</li>
        <li>
          Softening hard, cracked skin around the heels, enabling easy, painless
          removal by your podiatrist
        </li>
        <li>Improved circulation</li>
        <li>Stress relief and muscle relaxation</li>
        <li>
          Pain relief by gently warming the joints, helping with conditions
          including osteoarthritis, rheumatoid arthritis, fibromyalgia and other
          joint problems
        </li>
      </ul>

      <h2 className="gs-u-mb+">Safety Information</h2>
      <p className="gs-u-mb++">
        Paraffin wax is safe and clean for application on the skin. We adjust
        the wax's temperature to a level that prevents any burns or blisters,
        although individuals with sensitive skin might experience a heat rash,
        which could be itchy or bothersome. Should this happen, it's important
        to inform your podiatrist immediately.
      </p>

      <h2 className="gs-u-mb+">The Treatment</h2>
      <p className="gs-u-mb++">
        The process involves immersing the lower legs and feet in a bath of
        liquid paraffin wax, which keeps the warmth. As the wax hardens, the
        warmth is absorbed by the lower legs and feet, delivering the advantages
        mentioned previously.
      </p>
    </ServiceDetailLayout>
  );
};

export default ParaffinWaxBathDetail;
